module.exports = __webpack_public_path__ + "img/icon7.7f5746ca.svg";